import { cn } from '@/lib/utils'
import { LocalizedLink } from '@/components/LocalizedLink'

interface LogoProps {
  isScrolled?: boolean
  className?: string
}

export function Logo({ isScrolled, className }: LogoProps) {
  return (
    <LocalizedLink
      to="home"
      className={cn('flex items-center px-4', className)}
      aria-label="Nashi Argan — Home"
    >
      <span
        className={cn(
          'font-display tracking-[0.16em] uppercase italic text-bruno transition-all duration-500',
          isScrolled ? 'text-xl md:text-[1.4rem]' : 'text-2xl md:text-[1.65rem]'
        )}
        style={{ letterSpacing: '0.02em' }}
      >
        nashi{' '}
        <span className="not-italic font-light tracking-[0.4em] text-argan-deep">
          argan
        </span>
      </span>
    </LocalizedLink>
  )
}
